import React from 'react';
import { useTranslation } from 'react-i18next';
import { StatusDot } from '../svgs';
import { BOOKING_STAGE_COLORS_MAP } from '../../constants/booking';

const BookingStage = props => {
  const { stage = 'IN_PROGRESS', size = 'm', className = '' } = props;
  const { t } = useTranslation();

  return (
    <div className={`booking-stage ${className}`}>
      <StatusDot size={size} color={BOOKING_STAGE_COLORS_MAP[stage]} />
      <span className="booking-stage__stage-text">
        {stage && t(`cms:cms.students.list.column.stage.${stage.toLowerCase()}`)}
      </span>
    </div>
  );
};
export default BookingStage;
